import React, { useState } from 'react'
import AuthLayout from '../../components/auth/AuthLayout'
import ForgotPasswordForm from '../../components/auth/ForgotPasswordForm'
import { request_new_password } from '../../server/server'
import { useHistory } from 'react-router-dom'
import { usePageTitle } from '../../utils/util'

const ForgotPasswordScreen = () => {
    usePageTitle(`Upstrive Education - Forgot Password`)
    const history = useHistory()
    const [email, setEmail] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const onRequestNewPassword = async (email) => {
        setIsLoading(true)
        setErrorMessage('')

        try {
            const response = await request_new_password({ email })
            if (response.status === 200) {
                // Navigate to token verification screen
                history.push(`/auth/verify-token?email=${encodeURIComponent(email)}`)
            } else {
                const error = response?.data?.message || response.data
                setErrorMessage(error)
            }
        } catch (e) {
            console.log(e)
            setErrorMessage('Error')
        }

        setIsLoading(false)
    }

    const handleBackToLogin = () => {
        history.push('/login')
    }

    return (
        <AuthLayout>
            <ForgotPasswordForm email={email} setEmail={setEmail} onSubmit={onRequestNewPassword} onBack={handleBackToLogin} isLoading={isLoading} errorMessage={errorMessage} />
        </AuthLayout>
    )
}

export default ForgotPasswordScreen
